/******************
		* This is a helper method to make creating elements easier.
		* It allows you to pass an element tag as a string, an object of parameters, and some innerHTML in a single line
		* All events can be modified to prevent default or stop propagation
		* Usage Examples:
			blue.util.createElement('img', {class: '.imgClass', src: '//img.src', 'data-thing': 'value'})
			blue.util.createElement('div', {class: '.divClass', style: 'color: blue'}, '<span>Inner Span</span>')
	******************/

import { util } from '~/core';
export default function createElement(elType = 'div', attrs = {}, html = '') {
	const el = document.createElement(elType);
	Object.keys(attrs).forEach(key => {
		el.setAttribute(key, attrs[key]);
	});

	if (typeof html === 'object') {
		el.insertAdjacentElement('afterbegin', html);
	} else {
		el.insertAdjacentHTML('afterbegin', html);
	}
	return el;
}

util.createElement = createElement;
